/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcphosted_Hub_AuthInputs */

const en_mcphosted_hub_auth = /** @type {(inputs: Mcphosted_Hub_AuthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authenticate with your personal Bystep access key: the header Authorization: Bearer bs_… , or ?token=bs_… when the app only takes a URL.`)
};

const id_mcphosted_hub_auth = /** @type {(inputs: Mcphosted_Hub_AuthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masuk dengan kunci akses Bystep pribadimu: header Authorization: Bearer bs_… , atau ?token=bs_… kalau aplikasinya cuma menerima URL.`)
};

/**
* | output |
* | --- |
* | "Authenticate with your personal Bystep access key: the header Authorization: Bearer bs_… , or ?token=bs_… when the app only takes a URL." |
*
* @param {Mcphosted_Hub_AuthInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mcphosted_hub_auth = /** @type {((inputs?: Mcphosted_Hub_AuthInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcphosted_Hub_AuthInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mcphosted_hub_auth(inputs)
	return en_mcphosted_hub_auth(inputs)
});